export var analyticsTrack = function analyticsTrack(eventName, eventProperties) {
  try {
    return window.analytics.track(eventName, eventProperties);
  } catch (e) {
    return e.message;
  }
};
export default analyticsTrack;